var React = require('react');

function PrepaidCredit (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"fill":"#002842","fillRule":"nonzero","width":"60","height":"38","rx":"3","key":0}),React.createElement("text",{"fontFamily":"CircularPro-Bold, Circular Pro","fontSize":"10","fontWeight":"bold","letterSpacing":"-.188","fill":"#FFF","key":1},[React.createElement("tspan",{"x":"10","y":"18","key":0},"PREPAID"),React.createElement("tspan",{"x":"12.361","y":"29","key":1},"CREDIT")])]));
}

PrepaidCredit.defaultProps = {"width":"60","height":"38"};

module.exports = PrepaidCredit;

PrepaidCredit.default = PrepaidCredit;
